import styled from 'styled-components'

// assets
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'
import SearchIcon from '../../../../assets/img/search-icon.svg'
import DropdownIcon from '../../../../assets/img/dropdown-down-icon.png'

// components
import TextInput from '../../../../components/ui/TextInput/TextInput'

export const MainPage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
`

export const Header = styled.div`
position: relative;
display: flex;
flex: 0 0 auto;
flex-direction: row;
flex-wrap: wrap;
align-items: center;
min-height: 87px;
font-size: 0.7rem;
background: var(--color-primary);

&::before {
  content: ' ';
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: url('${MoreHeaderParticles}');
  background-repeat: no-repeat;
  background-position: right top;
}
`

export const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

export const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

export const Content = styled.div`
  /*flex: 1 1 auto;
padding: 0;
overflow: auto;
width: 100%;*/
`

export const SearchWrapper = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100px;
`

export const BlockSearchInput = styled(TextInput)`
  width: calc(100% - 7px);
  background-image: url(${SearchIcon});
  background-position: center right 10px;
  background-repeat: no-repeat;
  padding-right: 30px;
`

export const BlockDropdownInput = styled(TextInput)`
  width: calc(100% - 7px);
  background-image: url(${DropdownIcon});
  background-position: center right 10px;
  background-repeat: no-repeat;
  background-size: 1rem;
  padding-right: 30px;

  &::placeholder {
    text-overflow: ellipsis;
  }
`

export const ProfileNav = styled.ul`
  height: calc(100% - 187px);
  overflow: auto;
  list-style: none;
  /*margin: 1.5rem 1.1875rem;*/
  padding: 0;
  /*position: relative;*/
`

export const NavItem = styled.li`
  cursor: pointer;
  list-style: none;
  padding: 1rem;
  border-top: 1px solid var(--color-fg-lighter);
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: pointer;

  svg {
    color: var(--color-primary);
  }

  &:first-child {
    border-top: 0px;
  }

  &:hover {
    color: var(--color-primary);
  }
`

export const ItemName = styled.span`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  padding-left: 5px;
  font-size: 0.875rem;
`
